import { ActionStatus } from '../../../common/constants/action-status';
import { RemoveProductFromWishListRequest } from '../interfaces/wish-list-update-product.interface';
import { StoreState } from '../../../store/store.interface';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getRemoveProductFromWishlistsApiCallMagento } from '../apis/wish-list-remove-product.api';

export const removeProductFromWishList = createAsyncThunk(
  'wishList/removeProduct',
  async (request: RemoveProductFromWishListRequest) => {
    return await getRemoveProductFromWishlistsApiCallMagento(request);
  }, {
    condition: ((_arg, {getState}) => {
      const state = getState() as StoreState;
      return state.wishListState.removeProductFromWishList.status != ActionStatus.loading;
    })
  }
);
